import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/local/environment';
import { AddressAutoCompleteRequest, AddressSuggestion } from '../models/address';
import { CompanyData } from '../models/company-data';
import { L1L3AuthService } from 'ngx-auth-util-lib';

@Injectable({
  providedIn: 'root'
})
export class CompanyDataMgmtService {
  private onBoardingProgress = -1;
  private isSanctionedCompany: boolean = false;

  constructor(private http: HttpClient, private authService: L1L3AuthService) {}

  setOnBoardingProgress(number: number) {
    this.onBoardingProgress = number;
  }

  getOnBoardingProgress(): number {
    return this.onBoardingProgress;
  }

  getCompanyData(): Observable<CompanyData> {
    return this.http.get<CompanyData>(
      environment.backend.endpoint.host +
        environment.domain.endpoint.paths.prefix +
        environment.domain.endpoint.paths.companydata
    );
  }

  public getLogoOfCompanyData(): Observable<any> {
    return this.http.get(
      environment.backend.endpoint.host +
        environment.domain.endpoint.paths.prefix +
        environment.domain.endpoint.paths.companydata +
        environment.domain.endpoint.paths.logo,
      { responseType: 'arraybuffer' }
    );
  }

  updateCompanyData(updatedCompanyData: CompanyData, file?: File|null): Observable<CompanyData> {
    const formData: FormData = new FormData();
    formData.append('companyData', JSON.stringify(updatedCompanyData));

    if (updatedCompanyData.logoUpdated) {
      formData.append('logo', file as Blob);
    }

    return this.http.put<CompanyData>(
      environment.backend.endpoint.host +
        environment.domain.endpoint.paths.prefix +
        environment.domain.endpoint.paths.companydata,
      formData,
      {
        headers: {
          serializer: 'multipart'
        }
      }
    );
  }

  public deleteDomain(domainId: string): Observable<any> {
    const sourceTabId = this.authService.sourceTabId;
    let params = new HttpParams();

    if (sourceTabId) {
      params = params.append('sourceTabId', sourceTabId);
    }

    return this.http.delete<any>(
      environment.backend.endpoint.host + environment.domain.endpoint.paths.prefix + `/${domainId}`,
      {
        params
      }
    );
  }

  setSanctionedCompany(isSanctionedCompany: boolean) {
    this.isSanctionedCompany = isSanctionedCompany;
  }

  checkIsSanctionedCompany() {
    return this.isSanctionedCompany;
  }

  getAddressSuggestion(addressAutoCompleteRequest: AddressAutoCompleteRequest): Observable<AddressSuggestion[]> {
    return this.http.post<AddressSuggestion[]>(
      environment.backend.endpoint.host +
        environment.addresses.endpoint.paths.prefix +
        environment.addresses.endpoint.paths.auto_complete,
      addressAutoCompleteRequest
    );
  }
}
